
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import Header from "@/components/Header.vue";
import Bottom from "@/components/Bottom.vue";
import Product from "@/components/Product.vue";
import Partner from "@/components/Partner.vue";
import News from "@/components/News.vue";
import { selHomeDetail } from "@/api/index";
import { ProductModule } from "@/utils/CmsUtil";
export default defineComponent({
  name: "home",
  components: {
    Header,
    Bottom,
    Product,
    Partner,
    News
  },
  setup() {
    const detail = reactive({
      homeVideoUrl: "",
      url: "http://cdn.purewedding.com.cn/login_bg_new.jpg",
      newsModule: {},
      partnerModule: {},
      newsList: [],
      productModule: {},
      productModuleTop: {},
      productModuleBottom: {},
      productTitleDesc: new ProductModule(),
      productModuleTopImg: "",
      productModuleBottomImg: ""
    });

    const homeDetail = async () => {
      await selHomeDetail().then((res: any) => {
        res.data.forEach((val: any) => {
          switch (val.menu_code) {
            case "cms_product":
              detail.productTitleDesc.title = val.alias;
              detail.productTitleDesc.desc = val.description;
              detail.productModuleTop = val.children[0];
              detail.productModuleTopImg = val.children[0].articles[0].img;
              detail.productModuleBottom = val.children[1];
              detail.productModuleBottomImg = val.children[1].articles[0].img;
              break;
            case "JoinUs":
              detail.partnerModule = val;
              break;
            case "New":
              detail.newsModule = val;
              detail.newsList = val.articles;
              break;
          }
        });
      });
    };
    //子组件header传递参数
    const homeVideo = (val: any) => {
      detail.homeVideoUrl = val;
      console.log(detail.homeVideoUrl);
    };
    onMounted(() => {
      homeDetail();
      // selProductList();
    });
    return {
      ...toRefs(detail),
      homeVideo
    };
  }
});
